// import React from "react";
import { Container } from "react-bootstrap";
import { Col, Row, Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import BackArrow from "../../components/backArrow";
import SearchIcon from "@mui/icons-material/Search";
import { images } from "../../constants";
import ClearIcon from "@mui/icons-material/Clear";
import { useRef } from "react";
import Card from "react-bootstrap/Card";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { SuccessNotify, FailedNotify } from "../../constants/tostify";
import url from "../../config/axios";
import { useSelector } from "react-redux";
import { publishImage } from "../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import { getAsset } from "../../helpers/helper";
import { Add } from "@mui/icons-material";
const Addupdate = () => {
    const { name } = useSelector((state) => state.user);
    const { id } = useParams();
    const [displayimg, setDisplayimg] = useState();
      const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
    const [countrydata, SetCountrydata] = useState([]);
    const [isloading, setIsloading] = useState(false);
    const [getcountry] = useState();
    const [getcity, setGetcity] = useState([]);
    const [selectedcity, setSelectedcity] = useState("");
    const [selectedCountry, setSelectedCountry] = useState("");
    const [getState, setState] = useState([]);
    const [selectedstateone, setSelectedstateone] = useState("");
    const [selectedState] = useState();
    const [searchTerm, setSearchTerm] = useState("");
    const [hidefield, setHidefield] = useState(1);
    const [searchTermone, setSearchTermone] = useState("");
    const [hidestate, setHidestate] = useState(1);
    const [searchTermtwo, setSearchTermtwo] = useState("");
    const [hidecity, setHidecity] = useState(1);
    const [selectedImage, setSelectedImage] = useState();
    const [loading, setloading] = useState(false);
    const imageUrl = useSelector((state) => state.imgurl);
    const [uploadedImages, setUploadedImages] = useState([]);

    const navigate = useNavigate();


    useEffect(() => {
        url.get(`/tranportvehicle/id/?id=${id}`).then(async (res) => {
            setAddmore(res?.data?.data?.TransportVehicle);

        });
    }, []);

    const onDrop = async (acceptedFiles) => {
        try {
              setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });
            setAddmore((addmore) => ({
                ...addmore,
                images: abc
            }));

            setDisplayimg(abc);

        } catch (error) {
            FailedNotify("Failed! Try Again");
        }  finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
    }

    const { getRootProps, getInputProps } = useDropzone({
        accept: "image/*",
        onDrop,
    });

    const [addmore, setAddmore] = useState({
        userid: name._id,
        shopid: id,
        brandName: "",
        model: "",
        noPlate: "",
        color: "",
        country: "",
        state: "",
        city: "",
        contact: "",
        description: "",
        images: [""],
        businessType: "transportShop",
    });

    const handelupdate = (e) => {
        setIsloading(true);
        e.preventDefault();
        url
            .put(`/tranportvehicle/id?id=${id}`, addmore)
            .then(async (res) => {
                if (res.data.success) {
                    setIsloading(false);
                    setTimeout(() => {
                        SuccessNotify("Add Update Successfully");
                    }, 1000);
                    navigate(`/vehicaldetail/${id}/${addmore.shopid}`);
                }
            })
            .catch((e) => {
                setIsloading(false);
                FailedNotify("Failed To Update Try Again!");
            });
    };


    useEffect(() => {
        setAddmore((addmore) => ({
            ...addmore,
            images: imageUrl?.imgurl || "",
        }));
        // ...
    }, [imageUrl]);
    useEffect(() => {
        axios
            .get(
                "https://pkgstore.datahub.io/core/world-cities/world-cities_json/data/5b3dd46ad10990bca47b04b4739a02ba/world-cities_json.json"
            )
            .then((res) => SetCountrydata(res.data))

            .catch((error) => { });
    }, []);
    const country = [...new Set(countrydata.map((item) => item.country))];

    country.sort();

    const handelvalues = (e) => {
        setAddmore((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }));
    };
    const handleCountryChangecity = (event) => {
        const { value } = event.target;
        setSelectedcity(value);
    };
    const handleCountry = (e) => {
        let states = countrydata.filter(
            (state) => state.country === e.target.value
        );
        states = [...new Set(states.map((item) => item.subcountry))];
        states.sort();
        setState(states);
    };

    const handleCountryChange = (event) => {
        const { value } = event.target;
        setSelectedCountry(value);
    };

    const handleState = (e) => {
        let cities = countrydata.filter(
            (city) => city.subcountry === e.target.value
        );
        setGetcity(cities);
    };
    const handleCountryChangestate = (event) => {
        const { value } = event.target;
        setSelectedstateone(value);
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };
    const handleSearchChangestate = (event) => {
        setSearchTermone(event.target.value);
    };
    const handleSearchChangecity = (event) => {
        setSearchTermtwo(event.target.value);
    };

    const inputfile = useRef(null);


   const removeImage = (index) => {
    const updatedImages = [...displayimg];
    updatedImages.splice(index, 1);
    setDisplayimg(updatedImages);
  };
    return (
        <>
            <Container>
                <Row>
                    <div className="screenHeight d-flex justify-content-center align-items-center">
                        <Col lg={10} md={12} sm={12} xs={12} className="Form-Shadow">
                            <Row>
                                <Col className="">
                                    <div className="arrowback ps-3">
                                        <BackArrow back="/RestaurantAlldata" black="black" />
                                    </div>
                                </Col>
                            </Row>
                            <div className="p-4">
                                <Row className="pt-2 pb-2 px-3">
                                    <Col md={4} lg={4} xl={4}>
                                        <Form.Label className="custm-lble">
                                            Vehical brand Name
                                        </Form.Label>
                                        <Form.Control
                                            placeholder="Name"
                                            className="input-style form-control-seller"
                                            name="brandName"
                                            defaultValue={addmore?.brandName}
                                            onChange={(e) => handelvalues(e)}
                                        />
                                    </Col>
                                    <Col md={4} lg={4} xl={4}>
                                        <Form.Label className="custm-lble">Number Plate</Form.Label>
                                        <Form.Control
                                            placeholder="Number Plate"
                                            className="input-style  form-control-seller "
                                            name="noPlate"
                                            defaultValue={addmore?.noPlate}
                                            onChange={(e) => handelvalues(e)}
                                        />
                                    </Col>
                                    <Col md={4} lg={4} xl={4}>
                                        <Form.Label className="custm-lble">
                                            Vehical Color
                                        </Form.Label>
                                        <Form.Control
                                            placeholder="Vehical Color"
                                            className="input-style  form-control-seller"
                                            name="color"
                                            defaultValue={addmore?.color}
                                            onChange={(e) => handelvalues(e)}
                                        />
                                    </Col>
                                </Row>
                                <Row className="pt-2 pb-2  px-3">
                                    <Col md={3} lg={4} xl={4}>
                                        <Form.Label className="custm-lble">
                                            Vehical Model
                                        </Form.Label>
                                        <Form.Control
                                            placeholder="Vehical Model"
                                            className="input-style  form-control-seller"
                                            name="model"
                                            defaultValue={addmore?.model}
                                            onChange={(e) => handelvalues(e)}
                                        />
                                    </Col>
                                    <div className="col-md-4">
                                        <label
                                            htmlFor="inputPassword4"
                                            placeholder="First name"
                                            className="form-label labelSize"
                                        >
                                            Country*
                                        </label>
                                        <div className="blood-type input-style">
                                            <div className="d-flex">
                                                <div className="w-100">
                                                    <input
                                                        type="search"
                                                        value={searchTerm}
                                                        onChange={handleSearchChange}
                                                        placeholder="Search country here...."
                                                        className="w-100 search-input"
                                                        onClick={() => setHidefield(0)}
                                                    />
                                                </div>
                                                <div>
                                                    <span>
                                                        <SearchIcon className="search-icon-fs" />
                                                    </span>
                                                </div>
                                            </div>
                                            <select
                                                onClick={() => setHidefield(1)}
                                                value={selectedCountry}
                                                defaultValue={addmore?.country}
                                                onChange={(e) => {
                                                    handleCountryChange(e);
                                                    handleCountry(e);
                                                    handelvalues(e);
                                                }}
                                                className="b-radius selectSize w-100"
                                                name="country"
                                            >
                                                {hidefield && <option>{addmore?.country}</option>}
                                                {country
                                                    .filter((country) =>
                                                        country
                                                            .toLowerCase()
                                                            .includes(searchTerm.toLowerCase())
                                                    )
                                                    .map((country, index) => (
                                                        <option key={country} value={getcountry}>
                                                            {country}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <label
                                            htmlFor="inputPassword4"
                                            placeholder="First name"
                                            className="form-label labelSize"
                                        >
                                            State*
                                        </label>
                                        <div className="blood-type input-style">
                                            <div className="d-flex">
                                                <div className="w-100">
                                                    <input
                                                        type="search"
                                                        value={searchTermone}
                                                        onChange={handleSearchChangestate}
                                                        placeholder="Search state here...."
                                                        className="w-100 search-input"
                                                        onClick={() => setHidestate(0)}
                                                    />
                                                </div>
                                                <div>
                                                    <span>
                                                        <SearchIcon className="search-icon-fs" />
                                                    </span>
                                                </div>
                                            </div>
                                            <select
                                                onClick={() => setHidestate(1)}
                                                className="b-radius selectSize w-100"
                                                value={selectedstateone}
                                                aria-label="Default select example "
                                                name="state"
                                                defaultValue={addmore?.state}
                                                onChange={(e) => {
                                                    handleState(e);
                                                    handleCountryChangestate(e);
                                                    handelvalues(e);
                                                }}
                                            >
                                                {hidestate && <option>{addmore?.state}</option>}
                                                {getState
                                                    .filter((country) =>
                                                        country
                                                            .toLowerCase()
                                                            .includes(searchTermone.toLowerCase())
                                                    )
                                                    .map((country) => (
                                                        <option key={country} value={selectedState}>
                                                            {country}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-4 ">
                                        <label
                                            htmlFor="inputPassword4"
                                            placeholder="First name"
                                            className="form-label labelSize"
                                        >
                                            City
                                        </label>
                                        <div className="blood-type input-style">
                                            <div className="d-flex">
                                                <div className="w-100">
                                                    <input
                                                        type="search"
                                                        value={searchTermtwo}
                                                        onChange={handleSearchChangecity}
                                                        placeholder="Search city here...."
                                                        className="w-100 search-input"
                                                        onClick={() => setHidecity(0)}
                                                    />
                                                </div>
                                                <div>
                                                    <span>
                                                        <SearchIcon className="search-icon-fs" />
                                                    </span>
                                                </div>
                                            </div>
                                            <select
                                                onClick={() => setHidecity(1)}
                                                value={selectedcity}
                                                className="b-radius selectSize w-100"
                                                aria-label="Default select example"
                                                name="city"
                                                defaultValue={addmore?.city}
                                                onChange={(e) => {
                                                    handleCountryChangecity(e);
                                                    handelvalues(e);
                                                }}
                                            >
                                                {hidecity && <option>{addmore?.city}</option>}

                                                {getcity
                                                    .filter((country) =>
                                                        country.name
                                                            .toLowerCase()
                                                            .includes(searchTermtwo.toLowerCase())
                                                    )
                                                    .map((country) => (
                                                        <option key={country.name}>{country.name}</option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>
                                    <Col md={4} lg={4} xl={4}>
                                        <Form.Label className="custm-lble">Contact</Form.Label>
                                        <Form.Control
                                            placeholder="Contact"
                                            className="input-style form-control-seller"
                                            name="contact"
                                            defaultValue={addmore?.contact}
                                            onChange={(e) => handelvalues(e)}
                                            type="number"
                                        />
                                    </Col>
                                </Row>



                                <div className="ps-3 pe-3 pt-4">
                                    <Form.Label className="custm-lble">Description</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={5}
                                        name="description"
                                        defaultValue={addmore?.description}
                                        className="input-style p-1"
                                        onChange={(e) => handelvalues(e)}
                                    />
                                </div>
                                <div className="d-flex justify-content-between pt-2">
                                    <Col className="mt-3 ps-3">
                                     
                                        <Row>
    <Col lg="9" className="me-auto">
      <Row>
        <Col lg={2} className="mt-2 ms-1">
          <Card
            style={{
              width: "6rem",
              height: "6rem",
              position: "relative", // ✅ to position loader
            }}
            {...getRootProps()}
            className="dropzone"
          >
            {/* Show loader if uploading */}
            {isUploading ? (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background: "rgba(255,255,255,0.7)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  borderRadius: "0.5rem",
                }}
              >
                <div
                  className="spinner-border text-primary"
                  style={{ width: "1.5rem", height: "1.5rem" }}
                  role="status"
                ></div>
                <small className="mt-1">{uploadProgress}%</small>
              </div>
            ) : (
              <>
                <Card.Img className="imet-fit" src={images.AddImage} />
                <Card.Body>
                  <input
                    type="file"
                    id="file"
                    style={{ display: "none" }}
                    {...getInputProps()}
                    multiple
                    autoComplete="off"
                  />
                </Card.Body>
              </>
            )}
          </Card>
        </Col>

        {displayimg?.length > 0 && (
          <Col lg={7} className="mt-1 d-flex">
            {displayimg.map((image, index) => (
              <Card
                key={index}
                className="me-2 mt-1"
                style={{
                  width: "6rem",
                  height: "6rem",
                  border: "2px solid",
                  position: "relative",
                }}
              >
                <Card.Img
                  className="imet-fit upload-img mt-0"
                  src={getAsset(image)}
                  alt=""
                  crossOrigin="anonymous"
                />
                <div
                  className="close-btnone"
                  onClick={() => removeImage(index)}
                >
                  <ClearIcon />
                </div>
              </Card>
            ))}
          </Col>
        )}
      </Row>
    </Col>
  </Row>

                                    </Col>
                                    <div className="d-flex align-items-end pb-3 pe-3">
                                        <div className="btns">
                                            <button className="btn1">Cancel</button>
                                            <button
                                                className="btn2"

                                                onClick={handelupdate}
                                            >
                                                Update
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </div>
                </Row>
            </Container>
        </>
    );
};

export default Addupdate;
